/**
 * @generated SignedSource<<6958a4012ee3eeab96681993a3d56cf0>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLSnippetCreateInput = {|
  clientMutationId?: ?string,
  operationName?: ?string,
  query: string,
|};
export type Console_graphQLSnippetCreateMutation$variables = {|
  input: GraphQLSnippetCreateInput,
|};
export type Console_graphQLSnippetCreateMutation$data = {|
  +graphQLSnippetCreate: ?{|
    +graphQLSnippet: {|
      +url: string,
    |},
  |},
|};
export type Console_graphQLSnippetCreateMutation = {|
  response: Console_graphQLSnippetCreateMutation$data,
  variables: Console_graphQLSnippetCreateMutation$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Console_graphQLSnippetCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GraphQLSnippetCreatePayload",
        "kind": "LinkedField",
        "name": "graphQLSnippetCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLSnippet",
            "kind": "LinkedField",
            "name": "graphQLSnippet",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Console_graphQLSnippetCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GraphQLSnippetCreatePayload",
        "kind": "LinkedField",
        "name": "graphQLSnippetCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLSnippet",
            "kind": "LinkedField",
            "name": "graphQLSnippet",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "28e2a20444d8e82090e79f3a27cb1ee3",
    "id": null,
    "metadata": {},
    "name": "Console_graphQLSnippetCreateMutation",
    "operationKind": "mutation",
    "text": "mutation Console_graphQLSnippetCreateMutation(\n  $input: GraphQLSnippetCreateInput!\n) {\n  graphQLSnippetCreate(input: $input) {\n    graphQLSnippet {\n      url\n      id\n    }\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "83c4622734bafce40baabe045b025eb8";

module.exports = ((node/*: any*/)/*: Mutation<
  Console_graphQLSnippetCreateMutation$variables,
  Console_graphQLSnippetCreateMutation$data,
>*/);
